import { Check } from "lucide-react";
import { STEP_NAMES } from "@/lib/formConfig";

export default function ProgressBar({ step }) {
  const pct = Math.round((step / STEP_NAMES.length) * 100);
  return (
    <div data-testid="progress-step-indicator" className="space-y-3">
      <div className="sm:hidden">
        <div className="flex items-end justify-between mb-2">
          <p className="font-heading font-bold text-slate-900 text-lg">{STEP_NAMES[step - 1]}</p>
          <p className="text-xs font-semibold text-slate-500">
            Step {step} of {STEP_NAMES.length}
          </p>
        </div>
        <div className="h-2 rounded-full bg-slate-200 overflow-hidden">
          <div
            className="h-full rounded-full bg-rose-600 transition-[width] duration-500"
            style={{ width: `${pct}%` }}
          />
        </div>
      </div>

      <ol className="hidden sm:flex items-center">
        {STEP_NAMES.map((name, i) => {
          const n = i + 1;
          const done = n < step;
          const active = n === step;
          return (
            <li key={name} className={`flex items-center ${n < STEP_NAMES.length ? "flex-1" : ""}`}>
              <div className="flex flex-col items-center gap-1.5">
                <div
                  className={`h-9 w-9 rounded-full grid place-items-center text-sm font-bold border-2 transition-colors duration-300 ${
                    done
                      ? "bg-slate-900 border-slate-900 text-white"
                      : active
                        ? "bg-rose-600 border-rose-600 text-white shadow-md"
                        : "bg-white border-slate-300 text-slate-400"
                  }`}
                >
                  {done ? <Check className="h-4 w-4" /> : n}
                </div>
                <span
                  className={`text-[11px] font-semibold whitespace-nowrap ${
                    active ? "text-slate-900" : done ? "text-slate-600" : "text-slate-400"
                  }`}
                >
                  {name}
                </span>
              </div>
              {n < STEP_NAMES.length && (
                <div className={`flex-1 h-0.5 mx-2 mb-5 rounded ${done ? "bg-slate-900" : "bg-slate-200"}`} />
              )}
            </li>
          );
        })}
      </ol>
    </div>
  );
}
